module.exports = __webpack_public_path__ + "static/media/JAGProcess.9ead8525.png";